<template>
  <div>
    <b-row style="margin-top: 1em">
      <b-col cols="7">
        <b-card bg-variant="light" style="min-height: 180px">
          <b-row>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.consultant") }}:
              </h6>
            </b-col>
            <b-col>
              <b-input-group>
                <b-form-input
                  style="margin-top: 2px"
                  size="sm"
                  :placeholder="inquiry.agent.full_name"
                  disabled
                />
                <b-btn
                  v-if="getUserBrandPermissions.super_admin"
                  size="sm"
                  @click="changeAgentModal.show = true"
                >
                  <v-icon name="wrench"></v-icon>
                </b-btn>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.date_created") }}:
              </h6>
            </b-col>
            <b-col>
              <b-form-input
              style="margin-top: 2px"
              size="sm"
              :placeholder="inquiry.created_at.substring(0, 10)"
                disabled
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.start_date") }}:
              </h6>
            </b-col>
            <b-col>
              <b-input-group>
                <b-form-input
                  style="margin-top: 2px"
                  size="sm"
                  :placeholder="inquiry.contract_start_on"
                  disabled
                  />
                <b-btn
                  v-if="inquiry.status == 'pending'"
                  size="sm"
                  @click="changeStartDateModal.show = true"
                  >
                  <v-icon name="wrench"></v-icon>
                </b-btn>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.status") }}:
              </h6>
            </b-col>
            <b-col>
              <b-form-input
                style="margin-top: 2px"
                size="sm"
                :placeholder="inquiry.status"
                disabled
                /></b-col>
          </b-row>
          <b-row>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.payment_type") }}:
              </h6>
            </b-col>
            <b-col>
              <b-form-input
                style="margin-top: 2px"
                size="sm"
                :placeholder="inquiry.payment_type"
                disabled
                />
            </b-col>
          </b-row>
          <b-row v-if="inquiry.retroactive_invoicing">
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.retroactive_invoicing") }}:
              </h6>
            </b-col>
            <b-col>
              <b-form-input
                style="margin-top: 2px"
                size="sm"
                placeholder="Yes"
                disabled
                />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-card
              bg-variant="light"
              style="margin-bottom: 5px;"
              :border-variant="inquiry.customer.isComplete ? 'success' : 'danger'"
              >
              <b-btn
                size="sm"
                variant="info"
                style="float: right"
                @click="toCustomer"
              >
                {{ $t("globals.go_to_customer") }}
              </b-btn>
              <h5 class="text-info">{{ $t("globals.customer") }}:</h5>
              <hr />
              <h6 class="text-secondary">
                {{ inquiry.customer.company_name + ", " + inquiry.customer.company_country }}
              </h6>
            </b-card>
          </b-col>

        </b-row>
        <b-row>
          <b-col>
            <b-card bg-variant="light"  >
              <h5 class="text-info" >{{ $t("globals.company") }}: 
                <span class="text-secondary" v-if="inquiry.company && inquiry.company.name">{{ inquiry.company.name }}</span>
                <b-btn style="position: absolute; right: 0; bottom: 0;" v-if="getUserBrandPermissions.super_admin" size="sm" @click="changeCompanyModal.show = true">
                  <v-icon name="wrench"></v-icon>
                </b-btn>
              </h5>
            </b-card>
          </b-col>
        </b-row>

      </b-col>
    </b-row>
    <ulu-change-start-date-modal
      :show="changeStartDateModal.show"
      :close="closeChangeStartDateModal"
    />
    <ulu-change-agent-modal
      :show="changeAgentModal.show"
      :close="closeChangeAgentModal"
    />
    <ulu-change-company-modal
    :show="changeCompanyModal.show"
    :close="closeChangeCompanyModal"
  />
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    components: {
      "ulu-change-agent-modal": () =>
        import(
          "@/components/inquiries/inquiry/inquiry_details/InquiryChangeAgentModal"
        ),
      "ulu-change-company-modal": () => import("@/components/inquiries/inquiry/inquiry_details/InquiryChangeCompanyModal"),
      "ulu-change-start-date-modal": () =>
        import(
          "@/components/inquiries/inquiry/inquiry_details/InquiryChangeStartDateModal"
        )
    },
    props: {
      inquiry: {
        type: Object,
        default: () => {
          return {
            agent: {
              full_name: ""
            },
            status: "",
            created_at: "",
            contract_start_on: "",
            payment_type: "",
            retroactive_invoicing: false,
            customer: {
              id: 0,
              company_name: "",
              company_country: "",
              isComplete: false
            },
            company: {
              id: 0,
              name: "",
            }
          };
        }
      },
      reload: Function,
      orderExists: Boolean
    },
    data() {
      return {
        changeStartDateModal: {
          show: false
        },
        changeAgentModal: {
          show: false
        },
        changeCompanyModal: {
          show: false
        }
      };
    },
    methods: {
      toCustomer() {
        this.$router.push({
          name: "customer",
          params: { id: this.inquiry.customer.id }
        });
      },
      closeChangeAgentModal() {
        this.changeAgentModal.show = false;
        this.reload();
      },
      closeChangeCompanyModal() {
        this.changeCompanyModal.show = false;
        this.reload();
      },
      closeChangeStartDateModal() {
        this.changeStartDateModal.show = false;
        this.reload();
      }
    },
    computed: {
      ...mapGetters(["getUserBrandPermissions"])
    }
  };
</script>